(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/tracking.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/tracking.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _svs$ticketgames$tick = svs.ticketgames.ticketMappings.productMappings,
  mapProductType = _svs$ticketgames$tick.mapProductType,
  getProductByTicketId = _svs$ticketgames$tick.getProductByTicketId;
const logger = new svs.core.log.Logger('component:ticket-utility-tracking');
const capitalize = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};
setGlobal('svs.ticketgames.ticketUtility.utils.tracking', {
  sendAnalytics: function (transactionId, gameId, ticketPrice, ticketInfo) {
    let shouldHaveExtraData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    if (ticketInfo) {
      const items = [];
      const productName = ticketInfo.name;
      const extraData = {
        gameType: ticketInfo.type
      };
      const trackingItem = new svs.components.analytics.transactionItem(gameId, ticketInfo.name, ticketPrice, 1, shouldHaveExtraData ? extraData : undefined);
      items.push(trackingItem);
      const transaction = new svs.components.analytics.transaction(transactionId, ticketPrice, items, 0, 0, undefined, capitalize(productName));
      svs.components.analytics.trackTransaction(transaction);
    }
  },
  trackChooseNewTicket: gameCode => {
    const ticketType = mapProductType(gameCode);
    const ev = {
      category: 'Wager',
      action: 'ticket_choose_new',
      opt_label: ticketType
    };
    logger.debug(ev);
    svs.components.analytics.trackEvent(ev);
  },
  ticketCompleted: name => {
    svs.components.analytics.trackEvent({
      category: 'Wager',
      action: 'ticket_completed',
      opt_label: name
    });
  },
  ticketResult: (name, winAmount) => {
    svs.components.analytics.trackEvent({
      category: 'Wager',
      action: 'ticket_result',
      opt_label: name,
      opt_value: isNaN(winAmount) ? undefined : winAmount / 100
    });
  },
  trackScratchTicket: function (gameCode) {
    let numberOfUnredeemed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    const ticketType = mapProductType(gameCode);
    const ev = {
      category: 'VOUCHER',
      action: numberOfUnredeemed > 1 ? 'redeem_ticket' : 'redeem_ticket_single',
      opt_label: ticketType
    };
    logger.debug(ev);
    svs.components.analytics.trackEvent(ev);
  },
  trackTopBarActionQualtrics: (trackingLabel, trackingValue) => {
    svs.components.analytics.trackEvent({
      category: 'Qualtrics_ticket_topBar',
      action: 'Qualtrics avsluta spel',
      opt_label: trackingLabel,
      opt_value: trackingValue
    });
  },
  trackTopBarAction: (action, trackingLabel, trackingValue) => {
    svs.components.analytics.trackEvent({
      category: 'ticket_topBar',
      action,
      opt_label: trackingLabel,
      opt_value: trackingValue
    });
  },
  trackValidateManualValidation: type => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: 'manual-validation',
      opt_label: type || 'undefined'
    });
  },
  trackValidateQRCodeFailure: type => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: 'qr-code-failure',
      opt_label: type || 'undefined'
    });
  },
  trackValidateQRCodeSuccess: type => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: 'qr-code',
      opt_label: type || 'undefined'
    });
  },
  trackValidateQRCodeButton: (type, buttonText) => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: "qr-code-".concat(buttonText),
      opt_label: type || 'undefined'
    });
  },
  trackValidateOneTimePassword: type => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: 'scratch_ticket_validation',
      opt_label: type || 'undefined'
    });
  },
  trackValidateWithdrawal: type => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: 'withdrawal_ticket',
      opt_label: type || 'undefined'
    });
  },
  trackValidateCorrectNewTicket: type => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: 'correct_new_ticket',
      opt_label: type || 'undefined'
    });
  },
  trackValidateCorrectNewTicketMulti: type => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: 'correct_new_ticket_multi',
      opt_label: type || 'undefined'
    });
  },
  trackValidateBuyNewTicketsOnlineChosen: type => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: 'new_ticket_online',
      opt_label: type || 'undefined'
    });
  },
  trackValidateBuyNewTicketsOfflineChosen: type => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: 'new_ticket_offline',
      opt_label: type || 'undefined'
    });
  },
  trackValidateKeepWinChosen: type => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: 'ticket_win_save',
      opt_label: type || 'undefined'
    });
  },
  trackValidatedTicketResult: (type, win) => {
    svs.components.analytics.trackEvent({
      category: 'validate_ticket',
      action: win ? 'ticket_win' : 'ticket_lose',
      opt_label: type
    });
  },
  trackValidateVoucherRedeemPurchase: (type, buttonText) => {
    svs.components.analytics.trackEvent({
      category: 'Voucher redeem',
      action: "".concat(buttonText, "-purchase"),
      opt_label: type || 'undefined'
    });
  },
  trackValidateQualtrics: function () {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      numberOfTicketsPurchased = _ref.numberOfTicketsPurchased,
      winAmountValidatedTicket = _ref.winAmountValidatedTicket,
      winAmountNewTicket = _ref.winAmountNewTicket;
    svs.components.analytics.trackEvent({
      category: 'valideraQualtrics',
      action: numberOfTicketsPurchased,
      opt_label: winAmountValidatedTicket,
      opt_value: winAmountNewTicket
    });
  },
  trackValidatePurchaseTransactions: (transactionItems, id) => {
    if (!transactionItems || (transactionItems === null || transactionItems === void 0 ? void 0 : transactionItems.length) === 0) {
      return;
    }
    const transactionId = id ? id : 'validate-purchase'; 
    try {
      const productName = transactionItems[0].name;
      const totalPrice = transactionItems.reduce((acc, ticket) => acc + ticket.price, 0);
      const items = transactionItems.map(_ref2 => {
        let type = _ref2.type,
          name = _ref2.name,
          price = _ref2.price,
          _ref2$extraData = _ref2.extraData,
          extraData = _ref2$extraData === void 0 ? {} : _ref2$extraData;
        return new svs.components.analytics.transactionItem(type, name, price, 1, _objectSpread({
          validateOnline: true
        }, extraData));
      });
      const transaction = new svs.components.analytics.transaction(transactionId, totalPrice, items, 0, 0, undefined, capitalize(productName));
      svs.components.analytics.trackTransaction(transaction);
    } catch (e) {
      logger.debug("failed to track purchase transactions with id ".concat(transactionId), e);
    }
  },
  trackOrderHomeDividerOrderHomeSelected: () => {
    svs.components.analytics.trackEvent({
      category: 'Triss_postbox',
      action: 'Order_home'
    });
  },
  trackOrderHomeDividerSubscribeSelected: () => {
    svs.components.analytics.trackEvent({
      category: 'Triss_postbox',
      action: 'Subscribe'
    });
  },
  trackOrderHomeCartSelections: function () {
    let tickets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    try {
      const label = tickets.map(ticket => {
        var _getProductByTicketId;
        return "".concat((_getProductByTicketId = getProductByTicketId(ticket.id, false)) === null || _getProductByTicketId === void 0 ? void 0 : _getProductByTicketId.shortName, "-").concat(ticket.count);
      }).join(', ');
      const totalNumberOfTickets = tickets.reduce((acc, ticket) => acc + ticket.count, 0);
      svs.components.analytics.trackEvent({
        category: 'Triss_postbox',
        action: 'select_orderhome',
        opt_label: label,
        opt_value: totalNumberOfTickets
      });
    } catch (error) {
      logger.error("Error tracking OrderHome cart selections, ".concat(tickets), error);
    }
  },
  trackOrderHomeCartTicketCountChange: (productCode, countChange) => {
    try {
      const product = getProductByTicketId(productCode, false);
      const productName = product.shortName;
      svs.components.analytics.trackEvent({
        category: 'Triss_postbox',
        action: countChange > 0 ? 'addPostbox' : 'removePostbox',
        opt_label: productName
      });
    } catch (error) {
      logger.error("Error tracking OrderHome cart ticket count change, ".concat(productCode, ", ").concat(countChange), error);
    }
  },
  trackOrderHomeBuyTicketClick: label => {
    svs.components.analytics.trackEvent({
      category: 'Triss_postbox',
      action: 'postboxMoreTicket',
      opt_label: label
    });
  },
  trackOrderHomeOrderTransaction: (transactionId, orderItems, shippingCost) => {
    try {
      let totalOrderPrice = shippingCost;
      let eventName = orderItems.length > 1 ? 'Triss_mailbox_order_home' : '';
      const items = orderItems.map(item => {
        var _item$themeName;
        const productCode = String(item.productCode);
        const quantity = item.quantity;
        const product = getProductByTicketId(productCode, false);
        const productName = product.shortName;
        const price = product.price;
        totalOrderPrice += price * quantity;
        eventName = eventName || productName; 
        return new svs.components.analytics.transactionItem(productCode, productName, price, quantity, {
          orderPostbox: true,
          ticketCampaign: (_item$themeName = item.themeName) !== null && _item$themeName !== void 0 ? _item$themeName : '',
          ticketOrder: item.ticketOrder
        });
      });
      const transaction = new svs.components.analytics.transaction(transactionId, totalOrderPrice, items, 0, shippingCost, undefined, eventName);
      svs.components.analytics.trackTransaction(transaction);
    } catch (error) {
      logger.error("Error tracking OrderHome order transaction, ".concat(transactionId), error);
    }
  },
  trackOrderHomeReceiver: other => {
    const receiver = other ? 'send_to_other' : 'send_to_me';
    svs.components.analytics.trackEvent({
      category: 'Triss_postbox',
      action: receiver,
      opt_label: ''
    });
  },
  trackTicketsBallMenuClick: _ref3 => {
    let brand = _ref3.brand,
      product = _ref3.product;
    svs.components.analytics.trackEvent({
      category: "".concat(brand, "_nav"),
      action: 'click_productMenu',
      opt_label: product
    });
  },
  createTopBarTrackingLabel: _ref4 => {
    let isDemo = _ref4.isDemo,
      location = _ref4.location,
      gameCode = _ref4.gameCode;
    const prefix = isDemo ? 'demo' : location;
    return "".concat(prefix, "-").concat(mapProductType(gameCode));
  },
  gameSpecificTracking: {
    svstrissadventskalender150y22: {
      bet: () => {
        const ev = {
          category: 'TrissAdventskalender',
          action: 'bet'
        };
        logger.debug(ev);
        svs.components.analytics.trackEvent(ev);
      },
      openDoor: data => {
        const doorsOpened = data.ticket.revelationData.doorsOpened;
        const ev = {
          category: 'TrissAdventskalender',
          action: 'open_door',
          opt_label: doorsOpened
        };
        logger.debug(ev);
        svs.components.analytics.trackEvent(ev);
      },
      corrected: () => {
        const ev = {
          category: 'TrissAdventskalender',
          action: 'corrected'
        };
        logger.debug(ev);
        svs.components.analytics.trackEvent(ev);
      }
    },
    svstrissadventskalender150y24: {
      bet: () => {
        const ev = {
          category: 'TrissAdventskalender',
          action: 'bet'
        };
        logger.debug(ev);
        svs.components.analytics.trackEvent(ev);
      },
      openDoor: data => {
        const doorsOpened = data.ticket.revelationData.doorsOpened;
        const ev = {
          category: 'TrissAdventskalender',
          action: 'open_door',
          opt_label: doorsOpened
        };
        logger.debug(ev);
        svs.components.analytics.trackEvent(ev);
      },
      corrected: result => {
        var _result$data$revelati, _result$data;
        const _ref5 = (_result$data$revelati = result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.revelationData) !== null && _result$data$revelati !== void 0 ? _result$data$revelati : {},
          autoCorrected = _ref5.autoCorrected;
        const ev = {
          category: 'TrissAdventskalender',
          action: 'corrected',
          opt_label: autoCorrected ? 'auto' : 'manual'
        };
        logger.debug(ev);
        svs.components.analytics.trackEvent(ev);
      }
    }
  }
});

 })(window);